export default "__VITE_PUBLIC_ASSET__33ecd5d0__"